import $ from 'jquery'
import async from 'async'
import _ from 'lodash'

let _p = window.xwCommon,
    _this = {
    	title:"弹窗",
    	name:"popupWin",
    	initWin(vm){
    		//console.log(vm.info)
    		let order_id = vm.info.order_id, order_node_id = vm.info.order_node_id,
    			func = ( callback, reject ) => {
					async.waterfall([
						( next ) => {
							let u = _p.getApiUrl("table/list")
							$.post(u,{order_node_id},(json) => {
					          	let status = parseInt(json.status)
					          	if(200 !== status){
					            	switch(status){
					                    default: 
					                      if(_p.checkAjaxStatus(vm,json,_this.title)) break;
					                      //vm.$alert(json.msg,_this.title);
					                      next(new Error(json.msg))
					                      break;
					                }
					                return;
					          	}else{
						            next(null, json.data)
						        }
					        },"JSON")
						},
						( data, next ) => {
							if(data.length != 1){
								next(new Error("表单描述信息错误"))
							}else{
								next(null,data[0])
							}
						},
						( data, next ) => {
							//console.log(data)
							//vm.$set(vm,"popupItem", data)
							vm.popupItem = data
						}
					],(err) => {
		            	if(err) return reject(err)
		           		else return callback()
		            })
				}

			return new Promise(func)
    	}
    }
export default _this


// WEBPACK FOOTER //
// ./src/lib/car/order/popup.js